// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__39UgV","footer":"Form_footer__nkZT6"};